import {
    COVERAGE_DETAILS_REQUEST,
    COVERAGE_DETAILS_RESULT,
    COVERAGE_DETAILS_OPEN_MODAL,
    COVERAGE_DETAILS_CLOSE_MODAL,
    COVERAGE_DETAILS_GET_DEVICE_REQUEST,
    COVERAGE_DETAILS_GET_DEVICE_RESULT,
    COVERAGE_DETAILS_SET_DEVICE,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    error: null,
    device: null,
    devices: [],
    id: null,
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case COVERAGE_DETAILS_REQUEST:
            return { ...state, loading: true }

        case COVERAGE_DETAILS_RESULT:
            return { ...state, loading: false, result: action.payload }

        case COVERAGE_DETAILS_OPEN_MODAL:
            return { ...state, openModal: true, id: action.payload, loading: true }

        case COVERAGE_DETAILS_CLOSE_MODAL:
            return { ...state, openModal: false }

        case COVERAGE_DETAILS_GET_DEVICE_REQUEST:
            return { ...state, loading: true }

        case COVERAGE_DETAILS_GET_DEVICE_RESULT:
            return { ...state, loading: false, device: action.payload }

        case COVERAGE_DETAILS_SET_DEVICE:
            return { ...state, devices: action.payload }


        case CLEAR_REDUX:
            return ["", "COVERAGE_DETAILS"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};